//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { BodyText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';

interface CreateNewPurchaseConfirmationModalProps {
  closeModal: () => void;
  isModalOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const CreateNewPurchaseConfirmationModal = ({
  closeModal,
  isModalOpen,
  onCancel,
  onConfirm,
}: CreateNewPurchaseConfirmationModalProps) => {
  return (
    <Modal
      closeModal={closeModal}
      contents={
        <ContentWrapper>
          <BodyText>
            The changes you've made aren't covered by your selected purchase
            option. Continuing with these changes will create a new purchase
            with a different option.
          </BodyText>
          <BodyText>
            Are you sure you want to proceed with this change?
          </BodyText>
        </ContentWrapper>
      }
      isModalOpen={isModalOpen}
      primaryButtonInfo={{
        buttonContent: 'Yes, Create New Purchase',
        onClick: onConfirm,
        trackingId:
          SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_NEW_PURCHASE_CONFIRMATION_MODAL_CONFIRM_BUTTON,
      }}
      secondaryButtonInfo={{
        buttonContent: 'Cancel',
        onClick: onCancel,
        trackingId:
          SAMPLING_CAMPAIGNS_TRACKING_ID.CREATE_NEW_PURCHASE_CONFIRMATION_MODAL_CANCEL_BUTTON,
      }}
      shouldIncludeSecondaryButton={true}
      title='Are you sure?'
      width='medium'
    />
  );
};

const ContentWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[4]};
`,
);
